import { z } from "zod";

export enum RequestSectionContainerLayoutEnum {
    ROW = 1,
    COLUMN = 2,
}

export const RequestSectionContainerLayoutEnumSchema = z.nativeEnum(RequestSectionContainerLayoutEnum);